export const getAbsoluteUrl = (path: string = ''): string => {
    const baseUrl = process.env.REACT_APP_BASE_URL || `${window.location.protocol}//${window.location.host}/`

    return `${baseUrl}${path}`;
}
